import _ from 'lodash';

const VueLodash = {
  install(Vue, options) {
    Vue.prototype.$_ = _;
  }
};

export default VueLodash;
